export default __webpack_public_path__ + "static/media/h4.0abf5b7a.jpg";